<template>
    <span @click="scrollUp" class="scrollup" style="display: inline;">Наверх</span>
</template>

<script>
export default {
    methods: {
        scrollUp() {
            $("html, body").animate({ scrollTop: 0 }, 600);
        }
    }
}
</script>
